import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../context/authProvider'
import AuthorizationAPI from '../api/AuthorizationAPI'
import { QUERY } from '../api/AuthorizationAPI.model'

/**
 * The venue list, per account: another tab signing in as someone else changes
 * the user here without a reload, and the list must not carry over.
 */
export const restaurantsQueryKey = (uid: string | undefined) => [
  QUERY.RESTAURANTS,
  uid
]

/**
 * Who is signed in, as the account button shows it.
 *
 * Name and photo come from Firebase: the backend keeps neither and reads them
 * from there too. The venue's name is not kept after login (only its id and
 * currency are), so it is asked for again here, through the same endpoint.
 */
export function useCurrentAccount() {
  const { currentUser } = useAuth()
  const restaurantId = localStorage.getItem('restaurantId')

  const { data: restaurants } = useQuery({
    queryKey: restaurantsQueryKey(currentUser?.uid),
    queryFn: AuthorizationAPI.getRestaurantsList,
    enabled: !!currentUser
  })

  const email = currentUser?.email ?? ''
  const restaurant = restaurants?.find(
    entry => String(entry.id) === restaurantId
  )

  return {
    // An owner invited by email has no display name until they set one.
    name: currentUser?.displayName || email.split('@')[0],
    photoUrl: currentUser?.photoURL ?? null,
    restaurantName: restaurant?.name,
    restaurantId,
    // Every venue this account owns, for the switcher in the account menu.
    restaurants: restaurants ?? []
  }
}

export default useCurrentAccount
